
import { PageConfigService } from 'src/app/page-config.service';
import { element } from 'protractor';
import { Component, OnInit, HostListener, Input, EventEmitter, Output, } from '@angular/core';
import * as L from 'leaflet';
import { PublicService } from "../api/public.service";
import { Station } from '../models/api_models/station';
import { MarkerClusterGroup } from "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import 'leaflet/dist/leaflet.css';

@Component({
  selector: 'app-leaflet-map',
  templateUrl: './leaflet-map.component.html',
  styleUrls: ['./leaflet-map.component.scss']
})

export class LeafletMapComponent implements OnInit {


  constructor(private publicService: PublicService, private PageConfigService: PageConfigService) { this.PageConfigService.config.subscribe((x) => { this.InitialGps = x.map_config }) }

  InitialGps: any
  myfrugalmap;
  myFeatureGroup;

  IsWait: boolean;

  private _mapIsLoad = false;


  //////input zoom 
  private _zoom: number;
  get zoom(): number { return this._zoom }
  @Input() set zoom(zoom: number) { this._zoom = zoom; }

  ///////input current gps
  private _currentGps: [number, number];
  get currentGps() { return this._currentGps }
  @Input() set currentGps(currentGps) {
    this._currentGps = currentGps;
    if (this.myfrugalmap != null) { this.myfrugalmap.setView(this._currentGps, this._zoom); }
  }

  //////input station  
  private _stations: any[];
  get stations() { return this._stations }
  @Input() set stations(stations) {
    this._stations = stations;
    this.getStation();
  }


  stationLoaded: boolean = true;


  @Output() stationSelected: EventEmitter<Station> = new EventEmitter();



  myIconRechargeDispo = L.icon({
    iconUrl: 'assets/icon/recharge_disponible.svg',
    iconSize: [32, 32],
  });

  myIconRechargeOccupe = L.icon({
    iconUrl: 'assets/icon/recharge_occupe.svg',
    iconSize: [32, 32],
  });

  myIconRechargeBlocage = L.icon({
    iconUrl: 'assets/icon/recharge_blocage.svg',
    iconSize: [32, 32],
  });
//  autopartage
  myIconAutopartageDispo = L.icon({
    iconUrl: this.getMamSncf() === false ? 'assets/icon/autopartage_dispo.svg' : 'assets/icon/partage_mam.svg',
    iconSize: [32, 32],
  });

  myIconAutopartageOccupe = L.icon({
    iconUrl: this.getMamSncf() === false ? 'assets/icon/autopartage_occupe.svg' : 'assets/icon/partage_mam.svg',
    iconSize: [32, 32],
  });

  myIconAutopartageBlocage = L.icon({
    iconUrl: this.getMamSncf() === false ? 'assets/icon/autopartage_blocage.svg' : 'assets/icon/partage_mam.svg',
    iconSize: [32, 32],
  });
//  autre
  myIconAutreDispo = L.icon({
    iconUrl: 'assets/icon/solidrive_disponible.svg',
    iconSize: [32, 32],
  });

  myIconAutreOccupe = L.icon({
    iconUrl: 'assets/icon/solidrive_occupe.svg',
    iconSize: [32, 32],
  });

  myIconAutreBlocage = L.icon({
    iconUrl: 'assets/icon/solidrive_blocage.svg',
    iconSize: [32, 32],
  });
  //  velo
  myIconVeloDispo = L.icon({
    iconUrl: this.getMamSncf() === false ? 'assets/icon/velo.svg' : 'assets/icon/velo_mam.svg',
    iconSize: [32, 32],
  });

  myIconVeloOccupe = L.icon({
    iconUrl: this.getMamSncf() === false ? 'assets/icon/velo_occupe.svg' : 'assets/icon/velo_mam.svg',
    iconSize: [32, 32],
  });

  myIconVeloBlocage = L.icon({
    iconUrl: this.getMamSncf() === false ? 'assets/icon/velo_blocage.svg' : 'assets/icon/velo_mam.svg',
    iconSize: [32, 32],
  });




  getStation() {
    this.intiLeafLeat();

    let eventData = this.stationSelected;


    const markerCluster = new MarkerClusterGroup();

    this.stations.forEach(station => {

      // const marker = L.marker([station.latitude, station.longitude], { icon: myIcon[station.type], alt: station.id.toString()})

      switch (station.type) {
        case 0:
        case 7:
          if (station.status == "available") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconRechargeDispo, alt: station.id.toString() })
          }
          if (station.status == "reserved") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconRechargeOccupe, alt: station.id.toString() })
          }
          if (station.status == "unavailable" || station.status == "maintenance" || station.status == "closed") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconRechargeOccupe, alt: station.id.toString() })
          }
          break;
        case 6:
        case 10:
        case 12:
          if (station.status == "available") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconVeloDispo, alt: station.id.toString() })
          }
          if (station.status == "reserved") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconVeloOccupe, alt: station.id.toString() })
          }
          if (station.status == "unavailable" || station.status == "maintenance" || station.status == "closed") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconVeloOccupe, alt: station.id.toString() })
          }
          break;
        case 1:
        case 5:
        case 8:
          if (station.status == "available") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconAutopartageDispo, alt: station.id.toString() })
          }
          if (station.status == "reserved") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconAutopartageOccupe, alt: station.id.toString() })
          }
          if (station.status == "unavailable" || station.status == "maintenance" || station.status == "closed") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconAutopartageOccupe, alt: station.id.toString() })
          }
          break;
        default:
          if (station.status == "available") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconAutreDispo, alt: station.id.toString() })
          }
          if (station.status == "reserved") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconAutreOccupe, alt: station.id.toString() })
          }
          if (station.status == "unavailable" || station.status == "maintenance" || station.status == "closed") {
            var marker = L.marker([station.latitude, station.longitude], { icon: this.myIconAutreOccupe, alt: station.id.toString() })
          }
      }
      // .addTo(this.myfrugalmap).on("click", function(e) {

      //   eventData.emit(station);
      // });


      marker.on("click", function (e) {

        eventData.emit(station);
      });



      markerCluster.addLayer(marker)
    })


    this.myfrugalmap.addLayer(markerCluster);

  }

  //  [46.6651181,2.0463107]

  intiLeafLeat() {
    this.myfrugalmap = L.map('map').setView([this.InitialGps.lat, this.InitialGps.lng], this.InitialGps.zoom);
    this.myfrugalmap.scrollWheelZoom.disable();

    this.myFeatureGroup = L.featureGroup().addTo(this.myfrugalmap);
    // Après
  L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(this.myfrugalmap);



    this.stationLoaded = false;
    this._mapIsLoad = true
  }




  ngOnInit() {

  }




  positionError() {
    this.IsWait = false;
    alert("La géolocalisation n'est pas activée. Veuillez activer pour utiliser cette fonctionnalité")
  }




  getGPS() {
    if (navigator.geolocation) {
      this.IsWait = true;
      navigator.geolocation.getCurrentPosition(position => {

        const myIcon = L.icon({
          iconUrl: 'assets/img/Picto_Global/marker-icon-red.png',
          iconSize: [20, 29],
        });
        this.IsWait = false;
        this.myfrugalmap.setView([position.coords.latitude, position.coords.longitude], 16)
        L.marker([position.coords.latitude, position.coords.longitude], { icon: myIcon }).addTo(this.myfrugalmap);

      }, this.positionError)
        ;

    }
    else {
      alert('Geolocation is not supported by this device')
    }
  }








  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {

    if (event.key == "Control") {
      this.myfrugalmap.scrollWheelZoom.enable();
    }
  }
  @HostListener('window:keyup', ['$event'])
  disableKeyboardEvent(event: KeyboardEvent) {
    if (event.key == "Control") {
      this.myfrugalmap.scrollWheelZoom.disable();
    }
  }


  stationChangedHandler(stationFocus: Station) {
    // console.log(stationFocus);
    this.stationSelected.emit(stationFocus);
  }



  getMamSncf(){

    let host = location.host

    if( host === `mam.clem.mobi` ||  host === `www.mam.clem.mobi`){
      return true
    }else{
      return false
    }
  }


}
